module.exports = __webpack_public_path__ + "img/respected.72648512.png";